import Navbar from "../../../components/feature/Navbar";
import Footer from "../../../components/feature/Footer";
import BSSHero from "./components/BSSHero";
import BSSContent from "./components/BSSContent";
import BSSShopSection from "./components/BSSShopSection";
import BSSFormula from "./components/BSSFormula";
import BSSRelated from "./components/BSSRelated";
import BSSBottomCTA from "./components/BSSBottomCTA";

export default function BestBeigeSofasPage() {
  return (
    <div className="min-h-screen bg-[#FDFAF5]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <BSSHero />
        <div className="max-w-screen-xl mx-auto px-8 md:px-16">
          <BSSContent />
          <BSSShopSection />
          <BSSFormula />
        </div>
        <BSSRelated />
        <BSSBottomCTA />
      </main>
      <Footer />
    </div>
  );
}
